module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-2021-4.fd74cd81.jpg";